import { CSSProperties, useState } from 'react';
import { GoBackLinkComponent, leftHeaderContainerStyle } from '@vivli/shared/components';
import { StudyLookupComponent } from './study-lookup.component';
import { Size, Styles } from '@vivli/shared/theme';
import { first } from 'rxjs/operators';
import { useModalApiContext, useStudiesApiContext } from '@vivli/core/infrastructure/context';
import { StudySampleComponent } from './study-sample.component';
import { useNavigate } from 'react-router';
import { AdminHeaderTitleView, AdminHeaderView, ButtonView } from '@vivli/shared/views';

const containerStyle: CSSProperties = {
    height: '100%',
    overflow: 'auto',
};
const innerContainerStyle: CSSProperties = {
    paddingLeft: Size.INSET_SIZE,
    paddingRight: Size.INSET_SIZE,
    paddingTop: Size.PADDING,
    flex: 'auto',
};

export const SubmitNewStudyComponent = () => {
    const studiesService = useStudiesApiContext();
    const modalService = useModalApiContext();
    const navigate = useNavigate();
    const [nctValue, setNctValue] = useState<string>('');
    const [orgValue, setOrgValue] = useState<{ orgId: string; orgName: string; orgCode: string }>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [sampleStudy, setSampleStudy] = useState(null);

    const handleSearchError = (e) => {
        modalService.error(`Error looking up study by NCT ID - ${e}`);
        setIsLoading(false);
    };
    const handleError = (e) => {
        modalService.error(`Error creating study - ${e}`);
        setIsLoading(false);
    };

    const handleNctSearch = (nct) => {
        if (!/^NCT\d{8}$/gi.test(nct)) {
            return;
        }

        setIsLoading(true);
        studiesService
            .getSampleStudy(nct)
            .pipe(first())
            .subscribe((sample) => {
                setSampleStudy(sample);
                setIsLoading(false);
            }, handleSearchError);
    };

    const handleContinueClick = () => {
        setIsLoading(true);
        const sample = { ...sampleStudy, orgId: orgValue?.orgId, orgName: orgValue?.orgName, orgCode: orgValue?.orgCode };
        studiesService
            .addStudy(sample, true)
            .pipe(first())
            .subscribe({
                next: (newStudy) => {
                    setIsLoading(false);
                    modalService.message('Draft study created.  You may now upload study protocol or CSR documents.', {
                        showBackground: false,
                        showLogo: true,
                        showContinueButton: true,
                    });
                    navigate(`/admin/studies/submitStudy/${newStudy.id}/details`);
                },
                error: handleError,
            });
    };

    return (
        <div style={containerStyle} className="scrolly">
            <div>
                <AdminHeaderView>
                    <div style={{ flexDirection: 'column' }}>
                        <div style={{ ...leftHeaderContainerStyle, paddingBottom: 10 }}>
                            <GoBackLinkComponent />
                        </div>
                        <AdminHeaderTitleView title={'Submit New Study'} />
                    </div>
                </AdminHeaderView>
            </div>
            <div style={innerContainerStyle}>
                <StudyLookupComponent
                    nctValue={nctValue}
                    setNctValue={setNctValue}
                    handleNctSearch={handleNctSearch}
                    orgValue={orgValue}
                    setOrgValue={setOrgValue}
                />

                {sampleStudy && <StudySampleComponent sampleStudy={sampleStudy} />}

                <ButtonView
                    isLoading={isLoading}
                    style={Styles.Button.BUTTON_VIVLI_BLUE}
                    disabled={!nctValue || !orgValue || !sampleStudy}
                    onClick={handleContinueClick}
                >
                    Continue
                </ButtonView>
            </div>
        </div>
    );
};
